<template>
  <div>
    <template v-if="hasEnoughAiRequest">
      <p class="font-outfit-regular text-ai m-0">
        {{ $t('pages.onBoarding.aiRequestsBalance.generatingTemplateWillUse', { aiRequests: minAiRequestBalance }) }}
      </p>
      <p class="font-outfit-regular text-ai m-0">
        {{ $t('pages.onBoarding.aiRequestsBalance.yourCurrentBalance', { balance: currentBalance }) }}
      </p>
    </template>

    <div v-if="!hasEnoughAiRequest">
      <p class="font-outfit-regular text-red-light m-0">
        {{ $t('pages.onBoarding.aiRequestsBalance.generatingTemplateRequires', { aiRequests: minAiRequestBalance }) }}
      </p>
      <p class="font-outfit-regular text-red-light m-0">
        {{ $t('pages.onBoarding.aiRequestsBalance.yourCurrentBalance', { balance: currentBalance }) }}
      </p>

      <ib-button-basic
        v-if="!hasEnoughAiRequest"
        class="mt-4 mb-4"
        color="blue"
        icon="ib-icon-shopping-cart-2"
        height="43px"
        @click="dialogPurchaseAiRequestsVisible = true"
      >
        {{ $t('pages.onBoarding.aiRequestsBalance.purchaseRequests') }}
      </ib-button-basic>
    </div>

    <dialog-purchase-ai-requests
      :visible="dialogPurchaseAiRequestsVisible"
      @close="dialogPurchaseAiRequestsVisible = false"
    />
  </div>
</template>

<script>
import DialogPurchaseAiRequests from '@/views/Onboarding/Components/Dialogs/DialogPurchaseAiRequests.vue'

export default {
  name: 'OnboardingAiRequests',

  components: { DialogPurchaseAiRequests },

  inject: ['getAiRequests', 'getMinAiRequestsBalance'],

  data () {
    return {
      dialogPurchaseAiRequestsVisible: false
    }
  },

  computed: {
    aiRequests () {
      return this.getAiRequests()
    },

    minAiRequestBalance () {
      return this.getMinAiRequestsBalance()
    },

    currentBalance () {
      return this.aiRequests.amount - this.aiRequests.amountSpent
    },

    hasEnoughAiRequest () {
      return this.currentBalance >= this.minAiRequestBalance
    }
  }
}
</script>
